import { NubankService, SupersimService, TicketService } from "@libs/renegkit/index"

export function getLeadsCustomExperience() {
  const hasNubankCustomFlow = !!NubankService.getNubankExperience()
  const hasSupersimCustomFlow = !!SupersimService.getSupersimExperience()
  const hasTicketCustomFlow = !!TicketService.getTicketExperience()

  return hasNubankCustomFlow || hasSupersimCustomFlow || hasTicketCustomFlow
}

export function startLeadsCustomExperience() {
  NubankService.startNubankExperience()
  SupersimService.startSupersimExperience()
  TicketService.startTicketExperience()
}
